import Icon from 'veui/components/Icon'

Icon.register({
  'screen-board': {
    paths: [
      {
        d: 'M704 96H416V64a32 32 0 00-64 0v32H63a32 32 0 000 64v384a32 32 0 0032 32h167.78l-66.3 111.66a32 32 0 0055 32.68L337.22 576h92.66l86.68 144.46a32 32 0 1054.88-32.92L504.52 576H672a32 32 0 0032-32V160a32 32 0 000-64zm-64 416H127V160h513zM256 224h256a32 32 0 010 64H256a32 32 0 010-64zm192 160a32 32 0 01-32 32H256a32 32 0 010-64h160a32 32 0 0132 32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
